<template lang="pug">
  va-card(:title="$t('menu.payment_methods')")
    .row.align--right
    //- .flex.xs12(:style="{textAlign: 'right'}")
    //-     va-button(:style="{marginTop: '20px'}" default normal color="dark" icon="fa fa-plus" href="/admin/payment-method/0") {{$t('paymentMethods.addMethod')}}
    va-data-table(ref="paymentMethodsDataTable"  :fields='fields' :data='paymentMethods' :per-page='parseInt(perPage)' :loading='loading')
        
        template(slot='actions' slot-scope='props')
            va-button.ma-0(flat small color="gray" icon="fa fa-pencil" :href="'/admin/payment-method/'+props.rowData.uuid") {{ $t('tables.edit') }}
            //- va-button.ma-0(flat small color="danger" icon="fa fa-trash" @click.prevent="openModalDeletePaymentMEthod(props.rowData)") {{ $t('tables.delete') }}
    .modal 
    va-modal(v-model='showModalDeletePaymentMethod' size='small' :title=" $t('paymentMethods.modal.deleteMethod')" :message=" $t('paymentMethods.modal.deleteMethodText') " :okText=" $t('modal.confirm') " :cancelText=" $t('modal.cancel') " @ok='deleteMethod' @cancel='abortDeleteMethod')    
</template>

<script>
import { debounce } from "lodash";

export default {
    props: ["paymentMethods", "loading"],
    data() {
        return {
            perPage: "20",
            
            createdPage: 1,
            justCreated: true,
            showModalDeletePaymentMethod: false,
            animationHolder: null,
            createdPage: 1,
            methodToDelete:null,
        };
    },
    computed: {
        fields() {
            return [
                {
                    name: "title",
                    title: this.$t("tables.headings.title"),
                    width: "20%"
                },
                {
                    name: "slug",
                    title: this.$t("tables.headings.slug"),
                    width: "10%"
                },
                {
                    name: "description",
                    title: this.$t("tables.headings.description"),
                    width: "30%"
                },
                {
                    name: "fee",
                    title: this.$t("tables.headings.fee"),
                    width: "15%"
                },
                {
                    name: "__slot:actions",
                    width: "24%",
                    dataClass: "text-right"
                }
            ];
        }
    },

    mounted() {
        this.animate();
    },
    methods: {
        animate() {
            this.animationHolder = requestAnimationFrame(this.animate);
        },
        goTo(paymentMethod) {
            this.$router.push({
                path: "/admin/payment-method/" + paymentMethod.uuid
            });
        },

        search: debounce(function(term) {
            this.term = term;
        }, 400),
        openModalDeletePaymentMEthod(row) {
            this.methodToDelete = row
            this.showModalDeletePaymentMethod= true
        },
        abortDeleteMethod(){
            this.showModalDeletePaymentMethod= false

        },
        deleteMethod(){
            this.$axios.delete('api/orders/deletePaymentMethod',{data:{uuid:this.methodToDelete.uuid}}).then(axRes => {
            this.showToast(
            this.$t('paymentMethods.deletedSusseccfully'),
            {
                icon:'fa-check',
                position: 'bottom-right',
                duration: 3000,
                fullWidth: false,
                className: 'vuestic-toast'
            },
            );
            
            this.$emit('reloadPaymentMethods')
        }).catch(axErr => {
            this.showToast(
            this.$t('system.genericError'),
            {
                icon:'fa-warning',
                position: 'bottom-right',
                duration: 10000,
                fullWidth: false,
                className: 'vuestic-toast error'
            },
            )
        })
    },
    },
    beforeDestroy() {
        cancelAnimationFrame(this.animationHolder);
    }
};
</script>
